(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('ClasesAmbitoService', ClasesAmbitoService);

    ClasesAmbitoService.$inject = ['$resource'];

    function ClasesAmbitoService ($resource) {
    	   var resourceUrl =  'apo/profesores/:id/:idp/:tiponivel/:tipomodelo/:idins';

           return $resource(resourceUrl, {}, {
               'query': { method: 'GET', isArray: true},
               'get': {
                   method: 'GET',
                   transformResponse: function (data) {
                       if (data) {
                           data = angular.fromJson(data);
                       }
                       return data;
                   }
               },
               'obtener': {
                   method: 'GET',
                   transformResponse: function (data) {
                       if (data) {
                           data = angular.fromJson(data);
                       }
                       return data;
                   }
               },
               'save': {
            	   url:'apo/profesores',
            	   method: 'POST',
                   transformResponse: function (data) {
                       if (data) {
                           data = angular.fromJson(data);
                       }
                       return data;
                   }
               },
               'update': { method:'PUT' },
               'getTipoNivel': {
            	   url:'apo/getTipoNivel',
            	   method: 'POST'
               }
           });
       }
})();
